import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

interface TreeStructureProps {
  tab: string;
  setTab: (tab: string) => void;
}

export const TreeStructure = ({ tab, setTab }: TreeStructureProps) => {
  const { t } = useTranslation();
  const path = useLocation()
  const pathname = path.pathname;
  let paths: { [key: string]: { label: string; target?: string }[] } ;
  
  if( pathname === "/crm" ) {
    paths = {
      "Dossier clients": [{ label: t("Dossier clients") }],
      Missions: [
        { label: t("Dossier clients"), target: "Dossier clients" },
        { label: t("Missions") },
      ],
      Documents: [
        { label: t("Dossier clients"), target: "Dossier clients" },
        { label: t("Missions"), target: "Missions" },
        { label: t("Documents") },
      ],
    };
  } else {
    paths = {
      "Dossier clients social": [{ label: t("Dossier clients social") }],
      Salariés: [
        { label: t("Dossier clients social"), target: "Dossier clients social" },
        { label: t("Salariés") },
      ],
      Eléments: [
        { label: t("Dossier clients social"), target: "Dossier clients social" },
        { label: t("Salariés"), target: "Salariés" },
        { label: t("Eléments") },
      ],
      Bulletins: [
        { label: t("Dossier clients social"), target: "Dossier clients social" },
        { label: t("Bulletins") },
      ],
    };
  }

  const elements = paths[tab] || [];

  return (
    <nav
      key={tab}
      aria-label="Fil d'Ariane"
      className="flex flex-wrap items-center gap-x-1 gap-y-0.5 text-[11px] font-bold tracking-wider uppercase"
    >
      {elements.map((item, index) => (
        <span
          key={item.target ?? `leaf-${index}`}
          className="flex items-center gap-1"
        >
          {index > 0 && (
            <span aria-hidden="true" className="text-slate-300">
              /
            </span>
          )}
          {item.target ? (
            <button
              type="button"
              onClick={() => setTab(item.target as string)}
              className="cursor-pointer rounded text-slate-400 transition-colors hover:text-dca-blue focus-visible:ring-2 focus-visible:ring-indigo-300 focus-visible:outline-none"
            >
              {item.label}
            </button>
          ) : (
            <span className="text-slate-600">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
};
